import {
  actionTypes,
} from './actions';

const initialState = {
  accountNumber: null,
  token: null,
  authInProgress: false,
};

const setAccountNumber = (state, { accountNumber }) => ({
  ...state,
  accountNumber,
});

const setToken = (state, { token }) => ({
  ...state,
  token,
});

const setAuthInProgress = (state) => ({
  ...state,
  authInProgress: true,
});

const setAuthCompleted = (state) => ({
  ...state,
  authInProgress: false,
});

export default (state = initialState, action) => {
  const handlers = {
    [actionTypes.SET_ACCOUNT_NUMBER]: setAccountNumber,
    [actionTypes.SET_TOKEN]: setToken,
    [actionTypes.SET_AUTH_IN_PROGRESS]: setAuthInProgress,
    [actionTypes.SET_AUTH_COMPLETED]: setAuthCompleted,
  };
  return handlers[action.type]
    ? handlers[action.type](state, action)
    : state;
};
